<template>
	<div class="ng-scope show-sticky-calc blog-wraaper" :class="openModal ? 'modal-open' : ''">
		<headerNavigation :isHome="true" @openLoginMadal="openLoginMadal" @changeRegister="changeRegister">
		</headerNavigation>
		<template v-if="isMobile">
			<div class="global-header-spacer display-mobile" style="height: 0px;"></div>
			<div class="div-after-fixed-header" style="height: 103px;"></div>
		</template>
		<div class="container">
			<div class="row">
				<div class="col-md-8">
					<div class="content-area">
						<div class="site-main">
							<div v-for="(item,index) in lists" :key="index" class="" @click="openPage('/blogDetail?no='+item.id)">
								<div class="postbox">
									<div class="row">
										<div class="col-md-6">
											<a>
												<img :src="item.img" class="img-responsive bv-tag-attr-replace bv-lazyload-tag-img"/>
											</a>
										</div>
										<div class="col-md-6 cont">
											<div class="entry-header">
												<div class="title">
													<a>{{item.title}}</a>
												</div>
											</div>
											<a class="cat-name">{{item.typenames}}</a>
											<span class="date"></span>
											<div class="entry-content">
												<p>{{item.subheading}}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="nav-below" v-if="pagesize <= totalPage && lists.length > 0">
							<h3 class="assistive-text"></h3>
							<div class="nav-previous">
								<a href="javascript:void()" @click="loadMore">
									<div class="morepost">
										{{$t('common.loadmore')}}
										<img src="../../assets/images/down-arrow.jpg.bv.webp" class="bv-tag-attr-replace bv-lazyload-tag-img"/>
									</div>
								</a>
							</div>
						</div>
						<div class="nav-below no-more-inner" v-else>
							<span class="no-more">没有更多</span>
						</div>
					</div>
				</div>
				<div class="col-md-4">
					<div class="sidebar-container">
						<div class="sidebar-inner">
							<div class="widget-area">
								<div class="sidebar-two">
									<div class="blog-categoty-wrapper">
										<div class="categry-item" :class="!categoryIndex ? 'active' : ''" @click="changeCategory('')">{{$t('common.all')}}</div>
										<div class="categry-item" :class="categoryIndex == item.id ? 'active' : ''" @click="changeCategory(item.id)" v-for="(item,index) in categoryData" :key="index">{{item.title}}</div>
									</div>
								</div>
								<div class="sidebar-two">
									<div class="title-line">
										<span class="title">{{$t('product.ordernow')}}</span>
									</div>
									<a>
										<img src="../../assets/test/Labels.jpg.bv.webp" class="image"/>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footers></footers>
		<loginModal ref="loginRef" :isShow="showLoginModal" @closeLoinMadal="closeLoinMadal"></loginModal>
		<div v-if="openModal" class="modal-backdrop fade ng-scope in" style="z-index: 1040;"></div>
	</div>
</template>


<script>
	import headerNavigation from '../../components/headerNavigation.vue'
	import footers from '../../components/footers.vue'
	import loginModal from '../../components/loginModal.vue'
	import {printingKnowledgelist,queryPrintingKnowledge} from '../../api/api.js'
	
	export default {
		components: {
			headerNavigation,
			footers,
			loginModal
		},
		data() {
			return {
				isMobile: false,
				showLoginModal: false,
				openModal: false,
				pagesize:1,
				pagenum:10,
				lists:[],
				categoryData:[],
				totalNum:0,
				totalPage:1,
				categoryIndex:''
			};
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.init()
		},
		methods: {
			init(){
				var that = this;
				let params = {
					pagesize:this.pagesize,
					pagenum:this.pagenum,
				}
				printingKnowledgelist(params).then(res => {
					if (res.code == 200) {
						if(that.pagesize > 1){
							that.lists = that.lists.concat(res.data.list)
						}else{
							that.lists = res.data.list
						}
						that.pagesize++
						that.categoryData = res.data.typeVoList
						that.totalNum = res.data.total
						if(res.data.total > that.pagenum){
							that.totalPage = Math.ceil(res.data.total / that.pagenum);
						}
					}
				})
			},
			openLoginMadal() {
				this.showLoginModal = true
				this.changeRegister(false)
			},
			closeLoinMadal() {
				this.showLoginModal = false
			},
			changeRegister(e) {
				this.$refs.loginRef.changeRegisterType(e)
				this.showLoginModal = true
			},
			getByCategory(){
				var that = this;
				let params = {
					type:this.categoryIndex,
					pagesize:this.pagesize,
					pagenum:this.pagenum
				}
				queryPrintingKnowledge(params).then(res => {
					if (res.code == 200) {
						if(that.pagesize > 1){
							that.lists = that.lists.concat(res.data.list)
						}else{
							that.lists = res.data.list
						}
						that.pagesize++
						that.totalNum = res.data.total
						if(res.data.total > that.pagenum){
							that.totalPage = Math.ceil(res.data.total / that.pagenum);
						}
					}
				})
			},
			loadMore(){
				if(this.pagesize <= this.totalPage){
					if(!this.categoryIndex){
						this.init()
					}else{
						this.getByCategory()
					}
				}
			},
			changeCategory(id){
				this.categoryIndex = id
				this.pagesize = 1
				if(!this.categoryIndex){
					this.init()
				}else{
					this.getByCategory()
				}
				
			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/blog.css");
	.blog-wraaper {
		font-family: "Open Sans", sans-serif;
		background: #f3f4f5;
		color: #8c8c8c;
	}
	.global-header-spacer {
		height: 60px !important;
		display: block !important;
	}
	@media (min-width: 992px) {
	    .col-md-6 {
	        width: 50%;
	    }
	}
	@media (min-width: 992px) {
	    .col-md-4 {
	        width: 33.33333333%;
	    }
	}
</style>
